import React, { useContext, useRef } from "react";
import "./course.css";
import Navbar from "../../components/navbar/Navbar";
import logo from "../../images/white-logo.png";
import { Link, useParams } from "react-router-dom";
import Rightside from "../../components/rightside/Rightside";
import Rating from "../../components/rating/Rating";
import Banner from "../../components/banner/Banner";
import Bannerimg from "../../images/banner3.png";
import Table from "react-bootstrap/Table";
import Review from "../../components/review/Review";
import image from "../../images/banner5.png";
import Footer from "../../components/footer/Footer";
import FooterMob from "../../components/footer/FooterMob";

import Guide from "../../components/guide/Guide";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import parse from "html-react-parser";
import { baseUrl } from "../../context/BaseUrl";
import { ToastContainer } from "react-toastify";
import Rated from "../../components/filterRating/Rated";
import "react-toastify/dist/ReactToastify.css";
import SideBarContext from "../../context/SideBarContext";

const Course = () => {
  const { id } = useParams();
  const { adBanners } = useContext(SideBarContext);

  // const val = JSON.parse(localStorage.getItem('user'))
  // const vid = val.user._id
  // const token = val.token

  //for tab scroll
  const aboutToRef = useRef();
  const cardToRef = useRef();
  const mediumToRef = useRef();
  const refundToRef = useRef();
  const preparationToRef = useRef();
  const resultToRef = useRef();
  const formToRef = useRef();
  const dateToRef = useRef();
  const installmentToRef = useRef();
  const prepareToRef = useRef();
  const patternToRef = useRef();
  const writeReviewToRef = useRef();

  // const tabledata = [
  //   {
  //     event: "UPSC CAPF Notification 2022",
  //     date: "	20-Apr-2022",
  //     feature: "20-Apr-2022",
  //   },
  //   {
  //     event: "UPSC CAPF Notification 2022",
  //     date: "	20-Apr-2022",
  //     feature: "20-Apr-2022",
  //   },
  //   {
  //     event: "UPSC CAPF Notification 2022",
  //     date: "20-Apr-2022",
  //     feature: "20-Apr-2022",
  //   },
  //   {
  //     event: "UPSC CAPF Notification 2022",
  //     date: "	20-Apr-2022",
  //     feature: "20-Apr-2022",
  //   },
  // ];

  const [Data, setData] = useState(false);
  const [rating, setRating] = useState([]);
  const [ratingAvg, setRatingAvg] = useState(false);

  async function fetchData() {
    try {
      const response = await axios.get(`${baseUrl}/user/coursebyid/${id}`);
      setData(response.data.result);
      setRating(response.data.ratings);
      setRatingAvg(
        response.data.ratingAvg ? response.data.ratingAvg[0] : false
      );
    console.log("...........sdfhiufshsfhosfhsofhfsovnhs", response.data.result)

    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchData();

  }, []);

  return (
    Data && (
      <React.Fragment>
        <ToastContainer />
        <div className="home-background">
          <Navbar logoimg={logo} />
        </div>

        <div className="container-space">
          <Guide
            name={Data.course}
            tag={[
              Data.category ? Data.category.category_name : "",
              Data.subject,
            ]}
            average={(ratingAvg ? ratingAvg.rating / 2 : 0).toFixed(1)}
            count={ratingAvg ? ratingAvg.totalRatingCount : 0}
            link={writeReviewToRef}
            noimg={"img"}
          />

          <div className="tab-view">
            <ul className="nav sticky-top bg-white py-1 mb-4">
              <li>
                <Link
                  to=""
                  className="active"
                  onClick={() => aboutToRef.current.scrollIntoView()}
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to=""
                  className=""
                  onClick={() => prepareToRef.current.scrollIntoView()}
                >
                  Mode
                </Link>
              </li>
              <li>
                <Link
                  to=""
                  className=""
                  onClick={() => mediumToRef.current.scrollIntoView()}
                >
                  Medium
                </Link>
              </li>
              <li>
                <Link
                  to=""
                  className=""
                  onClick={() => preparationToRef.current.scrollIntoView()}
                >
                  Notes
                </Link>
              </li>
              <li>
                <Link
                  to=""
                  className=""
                  onClick={() => cardToRef.current.scrollIntoView()}
                >
                  Speciality
                </Link>
              </li>
              <li>
                <Link
                  to=""
                  className=""
                  onClick={() => resultToRef.current.scrollIntoView()}
                >
                  Mentorship
                </Link>
              </li>
              <li>
                <Link
                  to=""
                  className=""
                  onClick={() => installmentToRef.current.scrollIntoView()}
                >
                  Fee
                </Link>
              </li>
              {/* <li>
                <Link
                  to=""
                  className=""
                  onClick={() => patternToRef.current.scrollIntoView()}
                >
                  Pattern
                </Link>
              </li> */}
            </ul>

            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-8 col-md-7 col-sm-12 col-xs-12">
                  <div className="tab-content">
                    <div className="about pt-4 pt-md-5" ref={aboutToRef}>
                      <h5 className="hlt">About Course</h5>
                      <p>{parse(Data.about ? Data.about : "")}</p>
                      <div className="banner d-flex justify-content-center">
                  <a href={adBanners.page_banner.link}>
                    <img src={adBanners.page_banner.banner} alt="banner3" />
                  </a>
                </div>
                    </div>
                    {/* about end */}
                    <div className="admit pt-4 pt-md-5" ref={prepareToRef}>
                      <h5 className="hlt">Mode of the course( online or offline)</h5>
                      <p>{parse(Data.available ? Data.available : "")}</p>
                    </div>
                    <div className="admit pt-4 pt-md-5" ref={mediumToRef}>
                      <h5 className="hlt">Medium of the course</h5>
                      <p>{parse(Data.medium ? Data.medium : "")}</p>
                    </div>
                    <div className="admit pt-4 pt-md-5" ref={preparationToRef}>
                      <h5 className="hlt">Notes or extra classes availablility</h5>
                      <p>{parse(Data.preparation ? Data.preparation : "")}</p>
                    </div>
                    
                    <div className="admit pt-4 pt-md-5" ref={cardToRef}>
                      <h5 className="hlt">What makes us different</h5>
                      <p>{parse(Data.speciality ? Data.speciality : "")}</p>
                    </div>{" "}
                    {/* admit end */}
                    <div className="result pt-4 pt-md-5" ref={resultToRef}>
                      <h5 className="hlt">Personal Mentorship or guidance </h5>
                      <p>{parse(Data.guidance ? Data.guidance : "")}</p>
                      {/* <div className="application" ref={formToRef}>
                        <h5 className="hlt">Payment in Installment</h5>
                        <p>
                          {parse(
                            Data.installment ? Data.installment : ""
                          )}
                        </p>
                      </div> */}
                      {/* application end */}
                      
                      {/* dates end */}
                      <div className="notification pt-4 pt-md-5" ref={installmentToRef}>
                        <h5 className="hlt">Payment in Instalment</h5>
                        <p>
                          {parse(Data.installment ? Data.installment : "")}
                        </p>
                      </div>
                      <div className="dates pt-4 pt-md-5" ref={dateToRef}>
                        <h5 className="hlt">Fee refund policy</h5>
                        <p>{parse(Data.refund ? Data.refund : "")}</p>
                      </div>
                      {/* <div className="pattern" ref={patternToRef}>
                        <h5 className="hlt">Pattern</h5>
                        <p>{parse(Data.pattern ? Data.pattern : "")}</p>
                      </div> */}
                      <div className={"course-review"}>
                        <h4 className="pb-4">Reviews</h4>
                        {rating.map((val, key) => {
                          return (
                            <div className="rev row pb-5" key={key}>
                              <div className="col-md-1 col-3 d-flex justify-content-center align-items-start">
                                <h6>{val.name[0]}</h6>
                              </div>
                              <div className="text col-9 col-md-10">
                                <h5 className="d-flex justify-content-between text-capitalize">
                                  {val.name}{" "}
                                  <span>
                                    <Rated rated={val.rating} />
                                  </span>
                                </h5>
                                <p className="desc">{val.desc}</p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <Review
                        data={writeReviewToRef}
                        reload={fetchData}
                        institute_id={Data.institute_id}
                        courseid={Data._id}
                        url={"course"}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-5 col-sm-12 col-xs-12">
                  <div className="rigthside">
                    <Rating
                      reload={fetchData}
                      institute_id={Data._id}
                    />
                    <Rightside />
                    <div className="rightbann">
                      <Banner bannerimg={image} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <FooterMob />
      </React.Fragment>
    )
  );
};

export default Course;
